import axios from 'axios'
import { apiUrl } from '@/api/apiUrl'

const state = {
  merchant: []
}

const mutations = {
  FETCH_MERCHANTS(state, items) {
    state.merchant = items
  }
}

const actions = {
  getMerchant({
    commit
  }) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(apiUrl + "merchant", {}, config)
        .then(({
          data
        }) => {
          if (data.state_id == 0 && data.total > 0) {
            commit('FETCH_MERCHANTS', data.list)
            resolve
          }
        })
        .catch(err => {
          reject(err)
        });
    })
  }
}

const getters = {
  merchantList(state) {
    return state.merchant.sort((a, b) => {
      if (a.human_name > b.human_name) return 1
      if (a.human_name < b.human_name) return -1
      return 0
    })
  },
  merchantName: state => id => {
    if (state.merchant && state.merchant.length > 0 && id != null) {
      let item = state.merchant.find(el => el.id === id)
      if (item != undefined) return item['human_name']
      else return id
    } else {
      return ""
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
